import {useUserService} from '../../service/user/index'
import { IUser } from "../../service/user/interfaces/IUser";


const useCreateUser = () => {

    const {createUser} = useUserService()
  const createUserHooks = async (data: IUser) => {
  return await createUser(data)
  };
  return {
    createUserHooks,
  };
};

export default useCreateUser;
